export const defaultGroupEmailFormValue = {
  enabled: false,
};

export const defaultGroupMessageFormValue = {
  msTeams: {
    onApp: { enabled: false },
    onSiftWeb: { enabled: false },
  },
};

export const defaultOrgChartExportFormValue = {
  download: { enabled: true },
  print: { enabled: true },
  defaultRootIds: [],
};

export const defaultAssistantFormValue = {
  enabled: false,
};

export const defaultOnboardingFormValue = {
  enabled: false,
};

export const CARD_CONTENT_CLASSIC_STYLE_KEY_ADVANCED = 'classicAdvanced';
export const MAX_VISIBLE_CUSTOM_ATTRIBUTES = 10;
